import React from "react";
import { GsdTopNavGroups } from "./GsdRoleTabs.jsx";

/**
 * @param {object} props
 * @param {boolean} props.open
 * @param {() => void} props.onClose
 * @param {Array<{ id: string, label: string, items: object[] }>} props.groups
 * @param {Array<{ id: string, label: string, icon?: string, to?: string }>} [props.flatItems]
 * @param {(item: object, meta: object) => React.ReactNode} [props.renderLink]
 * @param {(item: object) => boolean} [props.isItemActive]
 * @param {{ label?: string, icon?: string }} [props.activeRole]
 * @param {React.ReactNode} [props.helpSlot]
 * @param {React.ReactNode} [props.trainingSlot]
 * @param {string} [props.testId]
 */
export function GsdMobileNav({
  open,
  onClose,
  groups = [],
  flatItems,
  renderLink,
  isItemActive,
  activeRole,
  helpSlot,
  trainingSlot,
  testId = "gsd-mobile-nav",
}) {
  const renderItem = (item) => {
    const active = isItemActive ? isItemActive(item) : false;
    const cls = `gsd-nav-item gsd-mobile-nav__item${active ? " gsd-nav-item--active" : ""}`;
    const content = (
      <>
        {item.icon ? <span aria-hidden="true">{item.icon}</span> : null}
        <span>{item.label}</span>
      </>
    );
    if (renderLink) {
      return (
        <div key={item.id} onClick={onClose}>
          {renderLink(item, { isActive: active, className: cls, children: content, onNavigate: onClose })}
        </div>
      );
    }
    return (
      <a key={item.id} href={item.to || item.href || "#"} className={cls} onClick={onClose}>
        {content}
      </a>
    );
  };

  return (
    <>
      <div
        className={`gsd-mobile-nav__backdrop${open ? " gsd-mobile-nav__backdrop--open" : ""}`}
        aria-hidden={!open}
        onClick={onClose}
        data-testid="gsd-mobile-nav-backdrop"
      />
      <div
        id="gsd-mobile-nav-panel"
        className={`gsd-mobile-nav${open ? " gsd-mobile-nav--open" : ""}`}
        aria-hidden={!open}
        data-testid={testId}
      >
        {activeRole ? (
          <div className="gsd-mobile-nav__role" data-testid="gsd-mobile-nav-role">
            {activeRole.icon ? <span aria-hidden="true">{activeRole.icon}</span> : null}
            <span>{activeRole.label}</span>
          </div>
        ) : null}

        {flatItems?.length ? (
          <div className="gsd-mobile-nav__group" data-testid="gsd-mobile-nav-flat">
            <div className="gsd-mobile-nav__items">{flatItems.map(renderItem)}</div>
          </div>
        ) : (
          groups.map((group) => (
            <div key={group.id} className="gsd-mobile-nav__group" data-testid={`gsd-mobile-nav-group-${group.id}`}>
              <span className="gsd-mobile-nav__group-label">{group.label}</span>
              <div className="gsd-mobile-nav__items">{group.items.map(renderItem)}</div>
            </div>
          ))
        )}

        {(helpSlot || trainingSlot) && (
          <div className="gsd-mobile-nav__shortcuts" data-testid="gsd-mobile-nav-shortcuts">
            {helpSlot}
            {trainingSlot}
          </div>
        )}
      </div>
    </>
  );
}

/** Re-export for desktop inline use */
export { GsdTopNavGroups };
